import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import { makeStyles } from '~/tools/makeStyles';
import { DEFAULT_RESULTS_TRANSLATION } from '../../../constants/results';

const useStyles = makeStyles(() => ({
  titleContainer: {
    minHeight: 70,
  },
  titleQuestion: {
    fontSize: 14,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '@supports (-webkit-line-clamp: 3)': {
      whiteSpace: 'initial',
      display: '-webkit-box',
      '-webkit-line-clamp': 3,
      '-webkit-box-orient': 'vertical',
    },
  },
  attributeBased: {
    backgroundColor: '#EEEEEE',
    borderRadius: 4,
    fontSize: 14,
    padding: '4px 8px',
    width: 150,
    textAlign: 'center',
  },
}));

export default function TitleText({
  isAttributeBased,
  title,
  attributesTitle,
  translation = DEFAULT_RESULTS_TRANSLATION,
}) {
  const classes = useStyles();
  return (
    <div tabIndex={0} className={classes.titleContainer}>
      <Tooltip title={title} placement="top">
        <Typography className={classes.titleQuestion}>{title}</Typography>
      </Tooltip>
      {isAttributeBased && (
        <Tooltip title={attributesTitle}>
          <Typography className={classes.attributeBased}>{translation.attributeBased.toUpperCase()}</Typography>
        </Tooltip>
      )}
    </div>
  );
}
